import React from 'react';
import PropTypes from 'prop-types';
import InputNumber from 'rc-input-number';
import styles from './Quantity.module.scss';
import { numberFormatter } from '../../../utils/formatHelper';

function Quantity(props) {
  const formatAndRunIfIsNumberString = (func, numberStr, variantId) => {
    const strNumber = numberStr ? numberFormatter(numberStr) : 0;
    if (strNumber) {
      func(strNumber, variantId);
    }
  };

  return (
    <div className={styles.input}>
      <InputNumber
        min={0}
        max={props.max}
        value={props.value}
        onChange={(quantity) => formatAndRunIfIsNumberString(props.onQuantityChange, quantity, props.variantId)}
        formatter={numberFormatter}
        onPressEnter={(event) =>
          props.onPressEnter && formatAndRunIfIsNumberString(props.onPressEnter, event.target.value, props.variantId)
        }
        onBlur={(event) =>
          props.onBlur && formatAndRunIfIsNumberString(props.onBlur, event.target.value, props.variantId)
        }
      />
    </div>
  );
}

export default Quantity;

Quantity.propTypes = {
  value: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  variantId: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onPressEnter: PropTypes.func,
  onBlur: PropTypes.func,
};
